"use client"
/* */
import { useStatic } from '../../lib/hooks/useStatic.mjs';
import { useSelector } from '../../lib/mobx/useSelector.mjs';
import { Timer } from '../../lib/timer/Timer.mjs';
import { makeObservable, action, observable } from 'mobx';

class NotificationController {
  notificationsData = /* @__PURE__ */ new Map();
  id = 0;
  constructor() {
    makeObservable(this, {
      notificationsData: observable.shallow,
      add: action.bound,
      remove: action.bound
    });
  }
  static useNew() {
    return useStatic(() => new NotificationController());
  }
  useNotifications() {
    return useSelector(() => Array.from(this.notificationsData.values()));
  }
  add(notification) {
    const id = this.id++;
    const meta = {
      id,
      createdAt: Date.now(),
      autoCloseTimer: new Timer()
    };
    this.notificationsData.set(id, {
      element: notification,
      meta
    });
    if (notification.props.autoClose) {
      meta.autoCloseTimer.start({ seconds: 10 }, () => {
        this.remove(id);
      });
    }
    return id;
  }
  remove(id) {
    this.notificationsData.delete(id);
  }
}

export { NotificationController, NotificationController as default };
//# sourceMappingURL=NotificationController.mjs.map
